import React, { Component } from 'react';
import './cw-pagination.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons'

class PaginationComponent extends Component {

    constructor(props) {
        super(props);

        if (this.props.maxPagesToDisplay)
            this.MAX_DISPLAY_PAGES = this.props.maxPagesToDisplay;
    }

    state = {
        totalPages: 1,
        maxDisplay: 20,
        currentSelectedPage: this.props.selectedPage || 1,
        previousSelectedPage: 1
    };
    startIndex = 1;

    MAX_DISPLAY_PAGES = 10;


    buildPagesNew(totalPages) {

        let elements = [];
        let startIndex = this.startIndex
        let pagesToDisplay = totalPages < (startIndex + this.MAX_DISPLAY_PAGES - 1) ? startIndex + (totalPages % this.MAX_DISPLAY_PAGES) : startIndex + this.MAX_DISPLAY_PAGES;

        for (let i = startIndex; i < pagesToDisplay; i++) {
            elements.push(<li className={(this.props.selectedPage == i) ? "page-item active" : "page-item"} onClick={this.onPageClick.bind(this, i)} key={"page_" + i}><button className="page-link">{i}</button></li>);
        }
        return elements;
    }

    nextPageHandler(totalPages) {

        if (this.state.currentSelectedPage == totalPages)
            return;

        let page = this.state.currentSelectedPage == totalPages ? totalPages : this.state.currentSelectedPage + 1;

        if (this.state.currentSelectedPage >= Math.ceil(this.startIndex / this.MAX_DISPLAY_PAGES) * this.MAX_DISPLAY_PAGES) {
            this.startIndex = this.startIndex + this.MAX_DISPLAY_PAGES;
        }

        this.onPageClick(page);

    }

    previousPageHandler(totalPages) {

        if (this.state.currentSelectedPage == 1)
            return;

        let page = this.state.currentSelectedPage == 1 ? 1 : this.state.currentSelectedPage - 1;

        if (this.state.currentSelectedPage == this.startIndex) {
            this.startIndex = this.startIndex - this.MAX_DISPLAY_PAGES;
        }

        this.onPageClick(page);
    }

    setSelectedPage(pageNumber) {
        this.setState({
            previousSelectedPage: this.state.currentSelectedPage,
            currentSelectedPage: pageNumber
        }, () => {
            this.props.onPageSelected(pageNumber, this.state.previousSelectedPage);
        });
    }

    onPageClick(pageNumber) {
        this.setSelectedPage(pageNumber);
    }

    render() {
        let totalPages = this.props.totalPages;

        return (
            <>
                {
                    totalPages ? <ul className="justify-content-end pagination pagination-sm">
                        <li className="page-item">
                            <button tabIndex="-1" className="page-link" onClick={this.previousPageHandler.bind(this, totalPages)}>
                                <FontAwesomeIcon icon={faAngleLeft} /><span className="sr-only">Previous</span>
                            </button>
                        </li>
                        {this.startIndex > this.MAX_DISPLAY_PAGES && <li className="page-item">....</li>}
                        {
                            totalPages && this.buildPagesNew(totalPages)
                        }
                        {totalPages > (this.startIndex + this.MAX_DISPLAY_PAGES - 1) && <li className="page-item">....</li>}
                        <li className="page-item">
                            <button className="page-link" onClick={this.nextPageHandler.bind(this, totalPages)}>
                                <FontAwesomeIcon icon={faAngleRight} /><span className="sr-only">Next</span>
                            </button>
                        </li>
                    </ul>
                        : ''}
            </>

        );
    }
}

export default PaginationComponent;